import { GridColumn } from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { protectedResources } from '../../authConfig';
import { BaseGrid } from '../../components/KendoGrid/BaseGrid';
import { NoCommaNumericFilterCell } from "../../components/KendoGrid/NumericFilterCell";
import { GuidFilterCell } from "../../components/KendoGrid/StringFilterCell";
import { AuditActionFilterCell } from "../../components/KendoGrid/AuditActionFilterCell";
import { DateRangeFilter } from "../../components/KendoGrid/DateRangeFilter";

const CommentAuditList = () => {
    const recentEntriesFirstSort = [{
        field: "AuditDate",
        dir: "desc"
    } as SortDescriptor];

    return (
        <BaseGrid verb={'POST'} pageTitle='Comment List' endpoint={protectedResources.audit.apiComment.endpoint + "KendoGridRead"} intialSort={recentEntriesFirstSort} key={Date.now()}>
            <GridColumn width="240px" field='auditDate' title='Audit Date' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="140px" field='auditAction' title='Action' filterCell={AuditActionFilterCell} />
            <GridColumn width="200px" field='modifiedByName' title='Modified By Name' />

            <GridColumn width="500px" field='text' title='Text' />
            <GridColumn width="200px" field='objectTypeName' title='Object Type Name' />
            <GridColumn width="200px" field='commentTypeName' title='Comment Type Name' />
            <GridColumn width="100px" field='id' title='ID' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='objectId' title='Object Id' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='objectTypeId' filterable={false} title='Object Type Id' filterCell={NoCommaNumericFilterCell} filter="numeric" />
            <GridColumn width="100px" field='commentTypeId' filterable={false} title='Comment Type Id' filterCell={NoCommaNumericFilterCell} filter="numeric" />

            <GridColumn width="340px" field='createdBy' title='Created By' filterCell={GuidFilterCell} />
            <GridColumn width="200px" field='createdByName' title='Created By Name' />
            <GridColumn width="240px" field='createdOn' title='Created On' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="340px" field='modifiedBy' title='Modified By' filterCell={GuidFilterCell} />
            <GridColumn width="240px" field='modifiedOn' title='Modified On' filter="date" filterCell={DateRangeFilter} />
            <GridColumn width="750px" field='auditUser' title='Audit User' />
        </BaseGrid>
    );
}

export default CommentAuditList;